import { useSelector } from '../../../../store'

export const usePresenceLoading = () => {
  const isLoading = useSelector((state) => state.presence.loading)

  return { isLoading }
}
